import { FC, memo } from "react";
import { ActivityIndicator, StyleSheet } from "react-native";
import { View, Text } from "@src/components";
import { useUnistyles } from "react-native-unistyles";

type BufferingOverlayProps = {
  message?: string;
};

export const BufferingOverlay: FC<BufferingOverlayProps> = memo(({ message = "Starting stream" }) => {
  const { theme } = useUnistyles();

  return (
    <View
      style={{
        ...StyleSheet.absoluteFillObject,
        justifyContent: "center",
        alignItems: "center",
        backgroundColor: "rgba(0, 0, 0, 0.35)",
      }}
    >
      <ActivityIndicator size="large" color={theme.colors.white.default} />
      <Text textStyle="md/regular" style={{ color: theme.colors.white.default }} mt="lg">
        {message}
      </Text>
    </View>
  );
});

BufferingOverlay.displayName = "BufferingOverlay";
